// extracted by mini-css-extract-plugin
export default {"main":"CustomerOverview_main__17Bth"};